export const notifications = {
  failedToInitSessionNotification: (msg: string) => ({ type: 'error', title: 'Failed to initialize session', message: msg }),
};

